import { Center, Stack, Title, Image, Group, Avatar, Text, Button } from "@mantine/core"
import SignUpStepper from "./SignUpStepper";
import { ReactNode, useContext } from "react";
import { getAuth, signOut } from "firebase/auth";
import { CompanyContext } from "./CompanyGateway";

export default function GatewayWrapper({ children, step }: { children: ReactNode, step: number | null }) {

  const auth = getAuth();
  const company = useContext(CompanyContext)


  return <Stack m="lg">
    <Group justify="space-between">
      <Center>
        <Image src={`logos/${company.id}.svg`} h="80" w="auto" pl="10" />
        <Title order={1} visibleFrom="md">{company.name}</Title>
      </Center>
      {auth.currentUser ? <Group pr="10">
        <Avatar src={auth.currentUser?.photoURL} radius="xl" visibleFrom="md" />
        <div style={{ flex: 1 }}>
          <Text size="sm" fw={500}>
            {auth.currentUser?.displayName}
          </Text>
          <Text c="dimmed" size="xs">
            {auth.currentUser?.email}
          </Text>
        </div>
        <Button onClick={() => signOut(auth)}>Logout</Button>
      </Group> : null}
    </Group>


    {step ? <SignUpStepper step={step} /> : null}
    {children}
  </Stack>
}